import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseMonitorWs } from "./ws.base";
import environment from "@/config";
import CloudMonitorWs from "./ws.cloud";
import BoxMonitorWs from "./ws.box";

export default getService<BaseMonitorWs>(environment.nexus, {
    box: BoxMonitorWs,
    cloud: CloudMonitorWs,
});
